
<!-- <button type="button" class="btn btn-primary mr-3 shadow-none" (click)="startTest()" style=" margin-left: 10px;">Start  Network Test</button>

<p  style=" margin-left: 10px;">Error if any : {{networkTestResult}}</p>

<br>

<button type="button" class="btn btn-primary mr-3 shadow-none" (click)="renderOtxCandidate()"  style=" margin-left: 10px;">Test Otx Candidate</button>


 add in diagnostic procedure page later -->
<!-- <div id="swUpgrade"></div> -->


<!--Commented by RR start-->
<button type="button" class="btn btn-primary mr-3 shadow-none" (click)="startTest()" style=" margin-left: 10px;">{{'Start Network Test'|translate}}</button>
<!--Commented by RR end-->

<!--Commented by RR start-->
<p style=" margin-left: 10px;" *ngIf="!isNetwork">{{'Error if any'|translate}} : {{networkTestResult}}</p>
<div *ngIf="progressbar" class="container">
<!--Commented by RR END-->
<!-- <div class="progress">
    <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%">
    </div>
  </div> -->
<!--Commented by RR start-->
<div class="progress">
    <div class="progress-bar progress-bar-striped s" style="width:100%"></div>
  </div>
  {{'Preparing for test'|translate}}..
</div>

<div *ngIf="!progressbar && isNetwork">
  {{'Network Test is Completed'|translate}}.
</div>

<br>

<input type="text" [(ngModel)]="queueId">
<br>
<button type="button" class="btn btn-primary mr-3 shadow-none" (click)="renderOtxCandidate()"
  style=" margin-left: 10px;">{{'Test Otx Candidate'|translate}}</button>
<!--Commented by RR END-->



<!-- add in diagnostic procedure page later -->
<!--Commented by RR start-->
<div id="swUpgrade"></div>

